import AccountUIModel from './account';
class UserProfileAccountUIModel {
  constructor({
    account = undefined,
  } = {}) {
    this.account = account ? new AccountUIModel(account) : null;
  }

  toApi() {
    return {
      '_meta':{
        'class':'ManageUserProfileAccount',
      },
      'account': this.account.toApi(),
    };
  }
}

export default UserProfileAccountUIModel;
